<template>
  <div class="std-search-bar">
    <slot></slot>
    <slot name="search-input">
      <vh-input
        round
        class="search-input"
        @input="onInput"
        v-model="internalValue"
        :placeholder="placeholder"
        :clearable="clearable"
        v-clearEmoji="emojiEnabed"
        size="medium"
        @clear="handleSearch"
        @keyup.enter.native="handleSearch"
      >
        <i class="vh-icon-search vh-input__icon" slot="prefix" @click="handleSearch"></i>
      </vh-input>
    </slot>
  </div>
</template>
<script>
  export default {
    name: 'StdSearchBar',
    props: {
      // 接收v-model中的数据
      value: {
        type: [String, Number],
        default: ''
      },
      clearable: {
        type: Boolean,
        default: true
      },
      placeholder: {
        type: String,
        default: '请输入查询关键字'
      },
      emojiEnabed: {
        type: Boolean,
        default: true
      }
    },
    computed: {
      internalValue: {
        get() {
          return this.value;
        },
        set(newValue) {
          this.$emit('input', newValue);
        }
      }
    },
    methods: {
      onInput(value) {
        this.$emit('input', value);
      },
      // 定义搜索函数
      handleSearch() {
        this.$emit('search', this.internalSearchText); // 发射搜索事件给父组件
      }
    }
  };
</script>
<style lang="less">
  .std-search-bar {
    width: 100%;
    margin-bottom: 16px;

    .vh-button {
      padding: 10px 19px;
    }

    .search-input {
      float: right;
      width: 220px;

      &.vh-input {
        ::v-deep .vh-input__inner {
          height: 36px;
          line-height: 36px;
        }
        ::v-deep .vh-input__icon {
          line-height: 36px;
        }
      }
      // 改写搜索输入框的清空小图标
      .vh-input__icon.vh-icon-circle-close.vh-input__clear:before {
        content: '\e756' !important;
      }
    }
  }
</style>
